module.exports = __webpack_public_path__ + "static/pa_1-7082a84b7d77cd134775d99e081e7fa9.jpg";